import React from "react";
import { usePermission } from "../../../../../../../../hooks/usePermission";
import { PERMISSIONS } from "../../../../../../../../consts/api";
import { Delete } from "./Delete";

export function Actions() {
  const canManageAppointments = usePermission(
    PERMISSIONS.appointments.manageAppointments,
  );

  const actions = [
    {
      id: "delete",
      component: Delete,
      isVisible: canManageAppointments.permitted,
    },
  ].filter((x) => x.isVisible);

  return (
    <div className="row eventDetailBtns">
      <div className="col-sm-4 col-xs-12">
        {actions.map((action) => (
          <action.component key={action.id} />
        ))}
      </div>
    </div>
  );
}
